import React from "react";
export default function Toast({ show, text }) {
  if (!show) return null;
  return (
    <div style={{
      position: "fixed", left: "50%", transform: "translateX(-50%)",
      bottom: 24, background: "#111827", color: "white",
      padding: "10px 16px", borderRadius: 8, boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
      zIndex: 1100, fontSize: 14
    }}>{text}</div>
  );
}
